import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import DropdownMenu from '../../../components/DropdownMenu'
import { fetchProducts, insertProduct } from "../../../services/products";
import { parseJwt } from "../../../utils/util";
const limit = 999
function Page(props) {
    const { partnerId:id } = parseJwt(props.token?.token); 
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [isloading,setIsloading]=useState(false)
 

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem/limit)||1
    const [data,setData]=useState([])
    const page =  parseInt(searchParams.get('page'))||1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type')||'全部'
    //
    const handleSearchName=(e)=>{setSearchParams({page:1,name:e.target.value})}
    useEffect(() => {
        if(!props.token.isLogin)return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    },[searchParams,props.token])
    async function fetchData(){
        const filter = {partnerId:id}
        if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
 
        if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchProducts(filter, {limit,skip:limit*(page-1),sort:{order:-1}})
        if(res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count/limit) || 1
        if(page > toPage) handleParamChange('page', 1)
    }

    function handleParamChange(key, val){
        searchParams.delete(key)
        if(val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item,index){
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    //new partner
    const [isAdding, setisAdding] = useState(false)
    const handleAddNewPartner=async ()=>{
        if(!isAdding.name) return alert('請輸入商品名稱')
        setIsloading(true)
        const res =  await insertProduct(props.token?.token,{
            name:isAdding.name,
            subtitle:'',
            description:'',
            price:0,
            isTcoin:true,
            status:'draft',
            order:99,
            data:{},
            type:"product",
            partnerId:props.partner._id,
            partnerName:props.partner?.name,
            thumbnail:'',
            tags:[],
            hero:'',
            discountMessage:"",
            content:[],
            isTshopRecommended:false,
            isTshopWeeklyPopular:false,
            isTshopTopViews:false,
            isTshopMostFavourited:false,
        })
        if(res.errno) return alert('新增失敗')
        setIsloading(false)
        setisAdding(false)
        alert('新增成功')
        fetchData()
    }

    return(
        <div className="h-full flex w-full flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]" style={{overflowY:'scroll'}}>
            <div className="w-full flex flex-row gap-[16px]">
                <input onChange={handleSearchName} placeholder="按商品名稱搜尋" className="p-[4px] rounded-[4px]"/>
                <div className="flex flex-row flex-1 justify-end gap-[16px]">
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部','草稿','已公開']}/>
                    <div onClick={()=>{setisAdding({})}} className="cursor-pointer text-[#6E604C] text-[12px] font-[700] p-[4px] rounded-[4px] bg-[#6E604C30] hover:opacity-80 items-center flex flex-row" style={{border:'1px solid #6E604C'}}>
                        + 新商品
                    </div>
                </div>
            </div>
            
            <div className="w-full flex flex-row gap-[16px] mt-[16px] border-[1px] border-[white] p-[16px] rounded-[8px] bg-[#ffffff90]">
                <div className="font-[700] text-[20px]">
                    T.Shop商品管理
                </div>
            </div>

            <div className="flex flex-row flex-wrap gap-[16px] mt-[16px] w-full justify-start">
                {['全部','草稿','已公開'].map((item,index)=>
                    <div key={index} onClick={()=>selectFilter(item)} className="cursor-pointer text-[18px] px-[16px] py-[4px]  hover:opacity-80 items-center flex flex-row" style={{color:filterType===item?'#6E604C':'#00000099',fontWeight:filterType===item?'700':'400',borderBottom:filterType===item?'2px solid #6E604C':'none'}}>
                        {item}
                    </div>
                )
                }

            </div>

            <div className="flex flex-row w-full gap-[16px] mt-[16px] flex-wrap">
                {data.map((item,index)=>{
                    return(
                        <div key={index} className="w-[200px] relative border-[1px] border-[white] gap-[6px] rounded-[16px] flex justify-center items-center flex-col bg-[#ffffff40]" style={{height:undefined,aspectRatio:1,overflow:'hidden'}}>
                            {item?.thumbnail?
                                <img src={item?.thumbnail} className="rounded-[16px]" style={{width:'60%',height:'60%',objectFit:'cover'}}/>
                                :<div/>
                            }
                            <div className="text-[10px] font-[700]">{item?.name}</div>
                            <div onClick={navigateTo(`/tshop/partners/tshop/${item._id}`)} className="cursor-pointer text-[#6E604C] text-[12px] font-[700] px-[24px] py-[4px] rounded-[4px] bg-[#6E604C30] hover:opacity-80 items-center flex flex-row" style={{border:'1px solid #6E604C'}}>
                                編輯
                            </div>
                        </div>
                    )
                })}
            </div> 

            {isAdding &&
                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-[#00000080] z-[9999]">
                    <div className="relative w-[400px] bg-white rounded-[16px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[20px] font-[700]">新增商品</div>
                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">商品名稱</div>
                        <input onChange={(e)=>{setisAdding({...isAdding,name:e.target.value})}} placeholder="請輸商品名稱" className="p-[4px] rounded-[4px] w-full border-[1px] border-[black]"/>
                        <div onClick={()=>{setisAdding(false)}} className="absolute top-[16px] right-[16px] cursor-pointer text-[black] text-[12px] font-[700] p-[4px] hover:opacity-80 items-center flex flex-row" >
                            X
                        </div>
                        <div onClick={handleAddNewPartner} className="cursor-pointer text-[#6E604C] text-[12px] font-[700] px-[24px] py-[4px] rounded-[4px] bg-[#6E604C30] hover:opacity-80 items-center flex flex-row mt-[16px]" style={{border:'1px solid #6E604C'}}>
                            確認
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)


